import React from "react";

/* eslint-disable max-len */
export default function CommentIcon({size}: {size?: number}) {
    return (
        <svg width={size || 10} height={size || 10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.5 0.5H0.5V7.5C0.5 8.60457 1.39543 9.5 2.5 9.5H7.5C8.60457 9.5 9.5 8.60457 9.5 7.5V2.5C9.5 1.39543 8.60457 0.5 7.5 0.5ZM3 2.5H2.5V3.5H3H7H7.5V2.5H7H3ZM2.5 4.5H3H7H7.5V5.5H7H3H2.5V4.5ZM3 6.5H2.5V7.5H3H5H5.5V6.5H5H3Z" fill="#63666A"/>
        </svg>
    );
}
